export default "__VITE_ASSET__9a6440d8__"